import React, { useEffect, useMemo, useState } from "react";
import styles from "./asset/adminSidebar.module.scss";

const AdminSidebar = () => {
    const [activeSection, setActiveSection] = useState("overview");
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1380);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 1380;
            setIsMobile(mobile);
            if (!mobile) {
                setIsOpen(false);
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const navItems = useMemo(
        () => [
            { id: "overview", label: "Overview", icon: "📊" },
            { id: "modules", label: "Modules", icon: "🧩" },
            { id: "queue", label: "Queue", icon: "📥" },
            { id: "system", label: "System", icon: "🛡️" },
        ],
        []
    );

    const scrollToSection = (sectionId) => {
        setActiveSection(sectionId);
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        if (isMobile) {
            setIsOpen(false);
        }
    };

    const toggleSidebar = () => {
        setIsOpen((prev) => !prev);
    };

    const closeSidebar = () => {
        setIsOpen(false);
    };

    return (
        <>
            {isMobile && (
                <button
                    className={styles.mobileToggle}
                    onClick={toggleSidebar}
                    aria-label="Toggle admin navigation menu"
                >
                    {isOpen ? "✕" : "☰"}
                </button>
            )}

            {isMobile && (
                <div
                    className={`${styles.overlay} ${isOpen ? styles.show : ""}`}
                    onClick={closeSidebar}
                />
            )}

            <aside className={`${styles.sideBar} ${isOpen ? styles.open : ""}`}>
                <div className={styles.logoContainer}>
                    <img
                        src={require("../../publicAsset/media/Prepal Logo 3.svg").default}
                        alt="Prepal Logo"
                        className={styles.logo}
                    />
                    <div>
                        <p className={styles.portalLabel}>Admin portal</p>
                        <h2 className={styles.portalTitle}>Control center</h2>
                    </div>
                </div>

                <nav className={styles.menuItems}>
                    {navItems.map((item) => (
                        <button
                            key={item.id}
                            type="button"
                            className={`${styles.menuItem} ${activeSection === item.id ? styles.active : ""}`}
                            onClick={() => scrollToSection(item.id)}
                        >
                            <span className={styles.menuIcon}>{item.icon}</span>
                            <span>{item.label}</span>
                        </button>
                    ))}
                </nav>

                <div className={styles.infoCard}>
                    <span className={styles.infoTag}>Internal</span>
                    <h3>Admin workspace</h3>
                    <p>Use this area for moderation, operations, and release monitoring.</p>
                </div>
            </aside>
        </>
    );
};

export default AdminSidebar;
